import React from 'react';
import PropTypes from 'prop-types';
import { view } from '@yola/ws-sdk';
import MediaPreview from 'src/js/modules/common/components/media-preview';
import getClosestBlockElement from 'src/js/modules/common/helpers/get-closest-block-element';

function ImagePreview({ url, mediaContainerElement, previewKey = undefined }) {
  const blockElement = getClosestBlockElement(mediaContainerElement);
  const blockElementId = view.accessors.getLiveElementId(blockElement);
  const placeholderType = view.accessors.getElementAttribute(blockElementId, 'category') || null;

  return <MediaPreview key={previewKey} url={url} type="image" placeholderType={placeholderType} />;
}

ImagePreview.propTypes = {
  url: PropTypes.string.isRequired,
  mediaContainerElement: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.object])
    .isRequired,
  previewKey: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default ImagePreview;
